
import React from 'react';
import { Info } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { LineItemMarkupTier } from '@/types/line-item-markup-tiers';
import { formatCurrency } from '@/lib/utils';

interface TierDescriptionProps {
  baseCost: number;
  applicableTier: LineItemMarkupTier | null;
}

const TierDescription: React.FC<TierDescriptionProps> = ({ 
  baseCost,
  applicableTier
}) => {
  return (
    <div className="mb-4">
      <p className="text-sm text-muted-foreground mb-2">
        Current base cost: <span className="font-semibold">{formatCurrency(baseCost)}</span>
        {applicableTier ? (
          <Badge className="ml-2 bg-green-500">
            Using {applicableTier.markup_percentage.toFixed(2)}% markup
          </Badge>
        ) : (
          <Badge className="ml-2" variant="outline">
            No matching tier
          </Badge>
        )}
      </p>
      
      <div className="mt-4 bg-slate-50 p-3 rounded-md">
        <div className="flex items-center text-xs text-muted-foreground">
          <Info className="h-4 w-4 mr-1" />
          <span>
            Tiers apply inclusively at min amount and exclusively at max amount. 
            E.g., R100-R200 applies if 100 ≤ x &lt; 200
          </span>
        </div>
      </div>
    </div>
  );
};

export default TierDescription;
